import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CapabilityRoleResponseDto } from '@domain/capability-role/dtos/capability-role.response.dto';
import { CreateCapabilityRoleRequestDto } from '@domain/capability-role/dtos/create-capability-role.request.dto';
import { ListCapabilityRoleRequestDto } from '@domain/capability-role/dtos/list-capability-role.request.dto';
import { UpdateCapabilityRoleRequestDto } from '@domain/capability-role/dtos/update-capability-role.request.dto';
import { UpdateStateCapabilityRoleRequestDto } from '@domain/capability-role/dtos/update-state-capability-role.request.dto';

@Injectable({
  providedIn: 'root',
})
export class CapabilityRoleService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('capability/role');
  }

  create(request: CreateCapabilityRoleRequestDto) {
    const queryUrl = `${this.getApiUrl()}`;
    return this.http.post<ApiResponse<CapabilityRoleResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateCapabilityRoleRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<CapabilityRoleResponseDto>>(
      queryUrl,
      request,
    );
  }

  updateState(request: UpdateStateCapabilityRoleRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/state`;
    return this.http.patch<ApiResponse<CapabilityRoleResponseDto>>(
      queryUrl,
      request,
    );
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<CapabilityRoleResponseDto>>(queryUrl, {});
  }

  list(request: ListCapabilityRoleRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<CapabilityRoleResponseDto>>
    >(queryUrl, { params: { ...request } });
  }
}
